export const ACCOUNT_STATEMENT = gql`
    query GetAccountStatement($statementId: Int!) {
        getAccountStatement(statementId: $statementId) {
            id
            accountStatementId
            startDateTime
            endDateTime
            statementDate
            createdAt
            outstandingBalance
            balanceBroughtForward
            totalInvoiceAmount
            totalCreditApplied
            totalPaymentsMade
            merchant {
                tradingName
                accountNumber
                contactName
                contactNumber
                billingAddress
                email
            }
            accountStatementItems {
                id
                transactionDate
                description
                credit
                debit
                sageInvoiceNumber
                sageCreditNoteNumber
                paymentMethod
                paymentId
                accountStatementId
                itemType
                rollingBalance
                createdAt
            }
        }
    }
`;
